import React from "react";
import Fetch from "react-fetch-component/dist/Fetch";
import Component from "./index";
import { cache } from "/store";

export default (props) => {
  const slug = props.match.params.slug;
  return (
    <Fetch url={"/content-api/works"} cache={cache}>
      {({ data: outerData }) => (
        <Fetch url={`/content-api/works/${slug}`} cache={cache}>
          {({ data }) => {
            if (data && outerData) {
              return (
                <Component
                  {...data}
                  slug={slug}
                  works={outerData.works || []}
                  {...props}
                />
              );
            }
            return null;
          }}
        </Fetch>
      )}
    </Fetch>
  );
};
